import * as React from 'react'
import { ErrorBase } from './ErrorBase'
import { useTranslation } from 'i18n'

export const Error404: React.FC = () => {
  const { t } = useTranslation('standalone.error')
  return <ErrorBase title="404 not found" description={t('404description')} />
}
